import React, { useState, useEffect, useMemo } from 'react';
import Loader from '../Common/Loader';
import { getFormattedNumber, roundToTwo } from '../utils/textUtils';
import { stockReport } from '../../services';

const StockReport = ({ resPacket, loading, warehouse }) => {
    const [show, setShow] = useState(false);
    const [itemList, setItemList] = useState([]);
    const [selectedItem, setSelectedItem] = useState({});

    useEffect(() => {
        if (!show) {
            setItemList([]);
            setSelectedItem({});
        }
    }, [show]);

    const total = useMemo(() => {
        if (!Array.isArray(resPacket) || resPacket.length === 0) {
            return { amount: 0, sumOfAmountAndTax: 0 };
        }

        return resPacket.reduce((acc, item) => {
            acc.amount += item.amount || 0;
            acc.sumOfAmountAndTax += item.sumOfAmountAndTax || 0;
            return acc;
        }, { amount: 0, sumOfAmountAndTax: 0 });

    }, resPacket);

    const getStockReportByItemId = (warehouse) => {
        // setSelectedItem(item);
        var request = {
            warehouseId: warehouse.value,

        };
        stockReport(request).then((res) => {
            if (res.responsePacket) {
                setItemList(res.responsePacket);
                setShow(true);
            }
        });
    };


    const getTotalAmount = (_row) => {
        const openQty = parseFloat(_row.altqty.split("::")[1].trim().split(" ")[0]);
        if (_row && !isNaN(_row.taxRate) && !isNaN(_row.amount)) {
            const taxRate = parseFloat(_row.taxRate);
            const amount = parseFloat(_row.rate * (_row.qty / openQty).toFixed(2));
            let taxAmount = (amount * taxRate) / 100;
            return getFormattedNumber(amount + taxAmount);
        } else {
            return "NA";
        }
    };

    const getNumber = (number) => {
        if (number && !isNaN(number)) {
            const _number = parseFloat(number);
            return getFormattedNumber(_number);
        } else {
            return number;
        }
    };

    if (loading) {
        return <Loader />;
    }

    if (resPacket?.length === 0) {
        return "No Records Found";
    }

    const getItemRate = (_row) => {
        const openQty = parseFloat(_row.altqty.split("::")[1].trim().split(" ")[0]);
        if (openQty === 0) {
            return _row.rate;
        } else {
            return _row.rate / openQty;
        }
    }

    const getAmount = (_row) => {
        const openQty = parseFloat(_row.altqty.split("::")[1].trim().split(" ")[0]);
        if (openQty === 0) {
            return _row.rate * _row.qty;
        } else {
            return _row.rate * (_row.qty / openQty).toFixed(2);
        }
    }



    return (
        <div className="customTable" id="scroll">
            <table className="customTable w-100">
                <thead className="fixed-thead">
                    <tr>
                        <td>SNO.</td>
                        <td>BATCH NO.</td>
                        <td>MFG DATE</td>
                        <td>EXPIRY DATE</td>
                        <td>ITEM CODE</td>
                        <td>ITEM NAME</td>
                        <td>CATEGORY</td>
                        <td>SUB CATEGORY</td>
                        <td className='text-center'>QTY</td>
                        <td>UOM</td>
                        <td>SKU</td>
                        {/* <td>CONVERSION</td> */}
                        <td className='text-center'>RATE</td>
                        <td className='text-center'>AMOUNT</td>
                        <td className='text-center'>TAX RATE</td>
                        <td className='text-center'>TOTAL AMOUNT</td>
                    </tr>
                </thead>
                <tbody className="body-scroll-custom">
                    {resPacket.map((row, i) => (
                        // <tr key={i} onClick={() => getStockReportByItemId(row)} style={{ cursor: "pointer" }}>
                        <tr key={i}>
                            <td>{i + 1}</td>
                            <td>{row.batchNumber}</td>
                            <td>{row.batchManufacturingDate}</td>
                            <td>{row.batchExpiredDate}</td>
                            <td>{row.itemCode}</td>
                            <td>{row.itemName}</td>
                            <td>{row.category}</td>
                            <td>{row.subCategory}</td>
                            <td className='text-right'>{getFormattedNumber(row.qty)}</td>
                            <td>{row.uom}</td>
                            <td>{row.sku}</td>
                            {/* <td>{row.altqty}</td> */}
                            <td className='text-right'>{row.openRate}</td>
                            <td className='text-right'>{row.amount}</td>
                            <td className='text-right'>{getNumber(row.taxRate)}</td>
                            <td className='text-right'>{row.sumOfAmountAndTax}</td>
                        </tr>
                    ))}
                    <tr>
                        <td>{resPacket.length}</td>
                        <td>{ }</td>
                        <td>{ }</td>
                        <td>{ }</td>
                        <td>{ }</td>
                        <td>{ }</td>
                        <td>{ }</td>
                        <td>{ }</td>
                        <td className='text-right'></td>
                        <td></td>
                        <td></td>
                        <td className='text-right'></td>
                        <td className='text-right'>{parseFloat(total.amount).toFixed(2)}</td>
                        <td className='text-right'>{parseFloat(total.sumOfAmountAndTax - total.amount).toFixed(2)}</td>
                        <td className='text-right'>{parseFloat(total.sumOfAmountAndTax).toFixed(2)}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default StockReport;
